










































































































































import Vue from "vue";
import anime from "animejs";
import mixins from "vue-typed-mixins";
import scroll from "scroll";
import scrollDoc from "scroll-doc";
import debounce from "debounce";

import { IPage } from "../store/state";
import { togglePage } from "../store/actions";
import PageExpander from "./PageExpander.vue";
import IsSmall from "../mixins/IsSmall";

const page = scrollDoc();

// Only scroll when spam is done.
const scrollBounced = debounce(($el: Element, isSmall: boolean) => {
  const y =
    $el.getBoundingClientRect().top + window.scrollY - (isSmall ? 85 : 65);
  scroll.top(page, y, { duration: 250 });
}, 275);

interface PageItemProps {
  focusContent: boolean;
  page: IPage;
  focus: boolean;
}
interface PageItemMethods {
  beforeOpen(e: HTMLElement): void;
  open(e: HTMLElement, done: () => void): void;
  beforeClose(e: HTMLElement): void;
  close(e: HTMLElement, done: () => void): void;
}
interface PageItemData {
  contentId: string;
}
interface PageItemComputed {
  minimenu: boolean;
  showExpander: boolean;
  contentClasses: any;
  contentRole: "tabpanel" | "region";
}

export default mixins(IsSmall).extend<
  PageItemData,
  PageItemMethods,
  PageItemComputed,
  PageItemProps
>({
  name: "PageItem",
  props: {
    focusContent: {
      type: Boolean,
      default: false
    },
    page: {
      type: Object,
      required: true
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      contentId: `${this.page.id}-content`
    };
  },
  methods: {
    beforeOpen(e) {
      e.style.overflow = "hidden";
    },
    open(e, done) {
      if (this.showExpander) {
        anime({
          targets: e,
          height: [0, e.clientHeight],
          duration: 250,
          easing: "linear",
          complete: () => {
            e.style.height = "auto";
            done();
          }
        });
      } else {
        done();
      }
    },
    beforeClose(e) {
      e.style.overflow = "hidden";
      e.style.height = `${e.clientHeight}px`;
    },
    close(e, done) {
      if (this.showExpander) {
        anime({
          targets: e,
          height: [e.clientHeight, 10],
          duration: 250,
          easing: "linear",
          complete: () => {
            e.style.height = "auto";
            done();
          }
        });
      } else {
        done();
      }
    }
  },
  computed: {
    contentRole() {
      if (this.showExpander) {
        return "region";
      } else {
        return "tabpanel";
      }
    },
    minimenu() {
      return this.$store.state.config.minimenu;
    },
    showExpander() {
      return !this.minimenu || this.isSmall;
    },
    contentClasses() {
      return {
        "kb-ia-list__item-content": true,
        "kb-ia-list__item-content--dots": true,
        "kb-ia-list__item-content--minimenu": this.minimenu
      };
    }
  },
  components: {
    PageExpander
  }
});
